
import Vue from 'vue'
import ReviewElements from './reviewElements'
export default ({
  namespaced: true,
  getters: {
    getCase(state) {
      return state.case
    },
    getCases(state) {
      return state.cases
    },
    getFormOptions(state) {
      return state.formOptions
    },
    getCaseListFormOptions(state) {
      return state.caseListFormOptions
    }
  },
  actions: {
    getCaseCount(context, params) {
      return Vue.axios.get('/api/cases/list', {
        params
      }).then((res) => {
        return parseInt(res.data)
      })
    },
    listCases(context, params) {
      return Vue.axios.get('/api/cases/list', {params}).then((res) => {
        return JSON.parse(res.data)
      })
    },
    loadCase(context, caseID) {
      Vue.axios.get('/api/case/load', {
        params: {
          id: caseID
        }
      }).then(function(res) {
        console.log(res)
      })
    },
    async saveCase(context, data) {
      return await Vue.axios.post('/api/case/save', data).then((res) => {
        return res.data
      })
    },
    loadFormOptions(context) {
      return Vue.axios.get('/api/case/formOptions').then((res) => {
        context.commit('FORMOPTIONS', res.data)
      })
    },
    loadCaseListFormOptions(context, params) {
      return Vue.axios.get('/api/case/list/formOptions', {params}).then((res) => {
        context.commit('CASE_LIST_FORMOPTIONS', res.data)
      })
    }
  },
  state: {
    case: {},
    cases: [],
    formOptions: [],
    caseListFormOptions: {}
  },
  mutations: {
    CASE_RPTA(state, reviewCase) {
      state.case = reviewCase
    },
    CASE_LIST(state, reviewCases) {
      state.cases = reviewCases
    },
    FORMOPTIONS(state, formOptions) {
      state.formOptions = formOptions
    },
    CASE_LIST_FORMOPTIONS(state, formOptions) {
      state.caseListFormOptions = formOptions
    }
  },
  modules: {
    reviewElements: ReviewElements
  }
})